import { render, staticRenderFns } from "./AllPartners.vue?vue&type=template&id=586da093&scoped=true&"
import script from "./AllPartners.vue?vue&type=script&lang=js&"
export * from "./AllPartners.vue?vue&type=script&lang=js&"
import style0 from "./AllPartners.vue?vue&type=style&index=0&id=586da093&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586da093",
  null
  
)

export default component.exports